import { render } from "./TableRegionAnalysis.vue?vue&type=template&id=ee0d764a"
import script from "./TableRegionAnalysis.vue?vue&type=script&lang=js"
export * from "./TableRegionAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__